// extracted by mini-css-extract-plugin
export default {"expand-button":"ExpandButton_expand-button__wsJo7","expanded":"ExpandButton_expanded__D3jNx"};